export const countryNames = {
  '036': 'Australia',
  '040': 'Austria',
  '056': 'Belgium',
  '076': 'Brazil',
  '124': 'Canada',
  '156': 'China',
  '208': 'Denmark',
  '246': 'Finland',
  '250': 'France',
  '276': 'Germany',
  '356': 'India',
  '360': 'Indonesia',
  '372': 'Ireland',
  '376': 'Israel',
  '380': 'Italy',
  '392': 'Japan',
  '458': 'Malaysia',
  '484': 'Mexico',
  '528': 'The Netherlands',
  '530': 'The Netherlands',
  '703': 'Slovakia',
  '710': 'South Africa',
  '724': 'Spain',
  '756': 'Switzerland',
  '158': 'Taiwan  (Province of China) ',
  '826': 'United Kingdom',
  '840': 'United States',
}
